<template>
  <v-dialog
    v-model="open"
    max-width="520"
    :retain-focus="false"
  >
    <v-card class="pa-5">
      <h2 class="text-h5 mb-4">
        {{ title }}
      </h2>
      <p>{{ message }}</p>
      <template v-if="kind !== 'error'">
        <p v-if="kind === 'ai'">
          AI Text uses 1 credit. Image restoration uses 5 credits. Add 100 credits for $5, or upgrade for a larger monthly allowance.
        </p>
        <p v-else>
          Upgrade for more space, or permanently delete media from your gallery. Your existing files remain available.
        </p>
        <p class="text-body-2">
          Billing opens in a new tab so you can keep this page open, then retry when your balance updates.
        </p>
        <v-btn
          color="primary"
          href="/billing"
          target="_blank"
          rel="noopener"
          class="mb-3"
        >
          {{ kind === 'ai' ? 'Add credits or upgrade' : 'View upgrade options' }}
        </v-btn>
      </template>
      <div>
        <v-btn
          text
          @click="open = false"
        >
          {{ kind === 'error' ? 'Close' : 'Back to my work' }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({ open: false, kind: '', message: '' }),
  computed: { title() { return ({ storage: 'More storage needed', ai: 'More AI credits needed' })[this.kind] || 'Unable to complete this action' } },
  mounted() { window.addEventListener('resources:notice', this.show) },
  beforeDestroy() { window.removeEventListener('resources:notice', this.show) },
  methods: { show(event) { this.kind = event.detail.kind; this.message = event.detail.message; this.open = true } },
}
</script>
